module.exports = __webpack_public_path__ + "94cbc3986e97a0bd8ae714744ad506a8.MP3";